import type { PaginatedResponse } from '@/types/api'

export interface PaginationMetaFromAPI {
  current_page: number
  total_pages: number
  total_count: number
  per_page: number
}

// The Rails Paginatable concern emits snake_case meta. Several endpoints used
// to pass it through untransformed, so `meta.totalPages` was undefined and
// pagination controls silently never rendered (the logged-in template pickers
// were stuck on page 1 of 20 with no way forward).
export function transformPaginationMeta(
  meta: PaginationMetaFromAPI
): PaginatedResponse<unknown>['meta'] {
  return {
    currentPage: meta.current_page,
    totalPages: meta.total_pages,
    totalCount: meta.total_count,
    perPage: meta.per_page,
  }
}
